import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Card from "react-bootstrap/Card";
import ModalPopup from "../../../../ModalPopup";
import { removePitch, updateLikes } from "../../../../../Datahandler";
import HeartSvg from "../../../../Shared/HeartSvg";
import { setInProgressPitch } from "../../../../ModalPopup/CreatePitchModal/redux/actions";
import Button from "../../../../Shared/Button";
import "../../../ProjectCard/projectCard.css";
import "../../pitches.css";
import "./pitchCard.css";

const PitchCard = ({ pitch, onViewMore }) => {
  const { imgUrl, title, description, contact, date, likes, uid, createdBy } = pitch;

  const loggedInUser = useSelector((state) => state.user.loggedInUser);
  console.log("loggedInUser:", loggedInUser); // Debug log
  console.log("pitch:", pitch); // Debug log

  const [isLiked, setIsLiked] = useState(
    loggedInUser ? (likes ? likes.includes(loggedInUser.uid) : false) : false
  );

  const [modalContent, setModalContent] = useState(null);

  const dispatch = useDispatch();

  const handleCloseModal = () => {
    setModalContent(null);
  };

  const handleLike = () => {
    if (loggedInUser) {
      updateLikes(uid, loggedInUser.uid, !isLiked)
        .then(() => {
          setIsLiked(!isLiked);
        })
        .catch((error) => {
          console.error("Error updating likes:", error);
        });
    }
  };

  const deleteIdea = (id) => {
    removePitch(id)
      .catch((error) => {
        console.error("Error deleting pitch:", error);
      });
  };

  const editIdea = () => {
    dispatch(
      setInProgressPitch({
        pitchDescription: description,
        pitchLink: imgUrl,
        pitchTitle: title,
      })
    );
    setModalContent("createPitch");
  };

  if (!loggedInUser || !pitch) {
    return null; // Render nothing if loggedInUser or pitch is undefined
  }

  return (
    <Card className="cardBox">
      {loggedInUser && loggedInUser.uid === createdBy && (
        <button className="deleteButton" onClick={() => deleteIdea(uid)}>
          <svg fill="#ff00a6" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" stroke="#ff00a6">
            <path d="M0 14.545L1.455 16 8 9.455 14.545 16 16 14.545 9.455 8 16 1.455 14.545 0 8 6.545 1.455 0 0 1.455 6.545 8z" fillRule="evenodd"></path>
          </svg>
        </button>
      )}
      {((loggedInUser && loggedInUser.uid === createdBy) || loggedInUser.level >= 1000) && (
        <button className="editButton" onClick={() => editIdea(uid)}>
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ff00a6">
            <path d="M15.4998 5.49994L18.3282 8.32837M3 20.9997L3.04745 20.6675C3.21536 19.4922 3.29932 18.9045 3.49029 18.3558C3.65975 17.8689 3.89124 17.4059 4.17906 16.9783C4.50341 16.4963 4.92319 16.0765 5.76274 15.237L17.4107 3.58896C18.1918 2.80791 19.4581 2.80791 20.2392 3.58896C21.0202 4.37001 21.0202 5.63634 20.2392 6.41739L8.37744 18.2791C7.61579 19.0408 7.23497 19.4216 6.8012 19.7244C6.41618 19.9932 6.00093 20.2159 5.56398 20.3879C5.07171 20.5817 4.54375 20.6882 3.48793 20.9012L3 20.9997Z" stroke="#ff00a6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
          </svg>
        </button>
      )}
      <Card.Img
        className="cardImage"
        variant="top"
        src={
          imgUrl
            ? imgUrl
            : "https://cdn2.vectorstock.com/i/1000x1000/88/26/no-image-available-icon-flat-vector-25898826.jpg"
        }
      />
      <Card.Body className="cardBody">
        <Card.Title className="cardTitle">{title}</Card.Title>
        <Card.Text>
          {description.length > 150
            ? description.slice(0, 150) + "..." // append ellipsis if text is truncated
            : description}
        </Card.Text>
        <section className={"bottomSection"}>
          <div className="view-more-button-container">
            <Button
              text="View more"
              buttonStyle="pink-transparent"
              onClick={() => {
                onViewMore(pitch);
              }}
            />
          </div>
          <div className="likeSection">
            <HeartSvg
              handleClick={handleLike}
              isFull={isLiked}
              disabled={!loggedInUser}
            />
            <p>{likes ? likes.length : 0}</p>
          </div>
        </section>
      </Card.Body>
      {modalContent !== null && (
        <ModalPopup
          show={modalContent}
          handleClose={handleCloseModal}
          description={description}
          title={title}
          image={imgUrl}
          type={modalContent}
          contact={contact ? contact : ""}
          date={date ? date : ""}
        />
      )}
    </Card>
  );
};

export default PitchCard;
